import { UsersProvider } from "../../contexts/UserContext";
import DeviceDrawer from "./components/DeviceDrawer";
import DeviceGrid from "./components/DeviceGrid";
import DeviceToolbar from "./components/DeviceToolbar";

import { DevicesProvider } from "./context/DevicesContext";

export default function DevicesTab() {
    return (
        <UsersProvider>
            <DevicesProvider>
                <DeviceToolbar />
                <DeviceGrid />
                <DeviceDrawer />
            </DevicesProvider>
        </UsersProvider>
    );
}
